import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

const collapsibleCardVariantClasses = {
  default: cn(
    'border border-border',
    // Two-layer resting elevation: a soft halo lift and a tight 1px under-line, both
    // resolved through --shadow-color so the shadow flips warm (bark) in newBrand and
    // neutral (black) in newBrandDark. Opacities are tuned higher than the inspiration's
    // pure-black reference (0.02 / 0.04) so the warm-tinted shadow still reads on light
    // surfaces — same compensation pattern --shadow-popover uses.
    'shadow-[0_4px_10px_-2px_rgb(var(--shadow-color)/0.08),0_1px_1px_0_rgb(var(--shadow-color)/0.10)]'
  ),
  // Surface stays so the card still reads as a surface, but border + resting
  // shadow are dropped. Use inside a container that already provides its own
  // chrome, or in dense stacked lists where per-item shadows would be noisy.
  flat: '',
} as const;

export const collapsibleCardVariants = cva(
  cn('rounded-lg bg-surface-shell px-3.5 py-3 text-text-primary'),
  {
    variants: {
      variant: collapsibleCardVariantClasses,
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
